import { h, render } from 'vue';

import AppTag from '../appTag/AppTag.vue';

import type {
  AppPreferencesTagsSettings,
  TagData,
  TagDataWithSize,
} from './AppPreferencesTags.model';

export function getElementSize(tag: TagData): number {
  const container = document.createElement('div');
  container.style.position = 'absolute';
  container.style.visibility = 'hidden';
  container.style.height = 'auto';
  container.style.width = 'auto';
  container.style.whiteSpace = 'nowrap';
  document.body.appendChild(container);

  const tagComponent = h(
    AppTag,
    {
      type: 'filter',
      size: 's',
      icon: {
        name: 'close',
        size: '13',
        position: 'right',
        color: 'color-white',
        clickable: true,
        ariaLabel: '',
      },
    },
    { title: () => tag?.text }
  );

  render(tagComponent, container);

  const width = container.offsetWidth;
  document.body.removeChild(container);
  return width;
}

export function calaculateAppPreferencesSettings(
  availableSpace: number,
  tags: TagDataWithSize[]
): AppPreferencesTagsSettings {
  const gapSize = 12;
  const moreButtonSize = 45;
  const plusButtonSize = 45;
  let shownTagsAmount = 0;
  let hiddenTagsAmount = 0;
  let result = availableSpace;

  result -= moreButtonSize + gapSize + gapSize + plusButtonSize;
  tags.forEach((tag: TagDataWithSize) => {
    result -= tag.width + gapSize;

    if (result > 0) {
      shownTagsAmount++;
      hiddenTagsAmount = tags.length - shownTagsAmount;
    }
  });

  if (hiddenTagsAmount === 1) {
    const availableSpaceWithoutMoreButton = result + gapSize + moreButtonSize;
    const lastTag = tags[tags.length - 1];
    if (lastTag && availableSpaceWithoutMoreButton > lastTag.width) {
      shownTagsAmount++;
      hiddenTagsAmount--;
    }
  }

  if (shownTagsAmount === 0) {
    return {
      shownTagsAmount: 0,
      hiddenTagsAmount: tags.length,
    };
  }

  return {
    shownTagsAmount,
    hiddenTagsAmount,
  };
}
